import moment from 'moment';
import React, { Fragment, memo, useEffect, useState } from 'react';
import { Form, InputGroup, Row, ButtonGroup, Button } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import AddPatientInfo from '../../components/doctors/modals/addPatientInfo';
import {
  agePrint,
  calculatePatientLabelPadding,
  capitalizeFirstLetter,
  separateDateTime,
  sizeConverter,
  defaultGeneralData,
  healthCalculation,
} from '../../utils/helpers';
import { ReactComponent as RightArrow } from '../../assets/icons/arrow-right.svg';

const PatientSection = ({
  patientPicture,
  patientInfo,
  isPad,
  appointmentInfo,
  setAppointmentInfo,
  prescriptionSetting,
  setPatientInfo,
  selectedOnExamination,
  setSelectedOnExamination,
  hideItems,
}) => {
  let { name, dob, phoneNumber } = patientInfo;
  const gender = patientInfo?.gender?.toLowerCase() || 'male';
  dob = separateDateTime(dob);

  const [infoModal, setInfoModal] = useState(false);
  const userInfo = useSelector((state) => state.authReducer.data);
  const patientSettings = useSelector(
    (state) => state?.prescriptionReducer?.prescriptionInfo?.patientSettings,
  );
  let generalExaminations =
    selectedOnExamination?.generalExaminations || defaultGeneralData();
  const items = patientSettings?.items;
  const itemsOrder =
    patientSettings?.itemsOrder?.length > 0
      ? patientSettings?.itemsOrder
      : null;

  console.log(items, 'items');
  const firstRow = items?.filter(
    (item) => item.rowNumber === 1 && item.isHidden === false,
  );
  const secondRow = items?.filter(
    (item) => item.rowNumber === 2 && item.isHidden === false,
  );
  const thirdRow = items?.filter(
    (item) => item.rowNumber === 3 && item.isHidden === false,
  );
  const ageProperties = items?.find((item) => item.name === 'age');
  let { unitProperties } = ageProperties || {};
  let { years, months, days, hours } = unitProperties || {};

  const checkAndCallHealthParameters = (activityLevel = '') => {
    console.log('checking parameters...');
    if (
      (generalExaminations.heightInfo?.feet &&
        generalExaminations.heightInfo?.heightUnit &&
        generalExaminations.weightInfo?.weight &&
        generalExaminations.weightInfo?.weightUnit) ||
      (generalExaminations.heightInfo?.cm &&
        generalExaminations.heightInfo?.heightUnit &&
        generalExaminations.weightInfo?.weight &&
        generalExaminations.weightInfo?.weightUnit)
    ) {
      const ageObj = separateDateTime(patientInfo?.dob);
      const parameters = {
        ...generalExaminations.heightInfo,
        ...generalExaminations.weightInfo,
        gender: patientInfo?.gender,
        age: ageObj?.years,
        activityLevel: activityLevel
          ? activityLevel
          : generalExaminations.activityLevel,
      };
      const healthResults = healthCalculation(parameters);
      console.log('healthResults results: ', healthResults);
      generalExaminations['bmi'] = healthResults.bmi;
      generalExaminations['bmr'] = healthResults.bmr;
      generalExaminations['bsa'] = healthResults.bsa;
      generalExaminations['tdee'] = healthResults.tdee;
      selectedOnExamination.generalExaminations = generalExaminations;
      setSelectedOnExamination({ ...selectedOnExamination });
    }
  };

  const handlePatientInput = (fieldName, val) => {
    if (fieldName === 'address') {
      let patientDetails = patientInfo?.patientDetails;
      const newDetails = { ...patientDetails, [fieldName]: val };
      setPatientInfo({
        ...patientInfo,
        patientDetails: newDetails,
      });
    } else if (
      fieldName === 'feet' ||
      fieldName === 'inch' ||
      fieldName === 'cm' ||
      fieldName === 'heightUnit'
    ) {
      console.log('working......', fieldName, val);
      // generalExaminations.heightInfo[fieldName] = val;
      setSelectedOnExamination({
        ...selectedOnExamination,
        generalExaminations: {
          ...generalExaminations,
          heightInfo: { ...generalExaminations?.heightInfo, [fieldName]: val },
        },
      });
      checkAndCallHealthParameters();
    } else if (
      fieldName === 'weight' ||
      fieldName === 'weightUnit' ||
      fieldName === 'weightShowInPrescription'
    ) {
      // generalExaminations.weightInfo[fieldName] = val;
      setSelectedOnExamination({
        ...selectedOnExamination,
        generalExaminations: {
          ...generalExaminations,
          weightInfo: { ...generalExaminations?.weightInfo, [fieldName]: val },
        },
      });
      checkAndCallHealthParameters();
    } else if (fieldName === 'bloodGroup') {
      setSelectedOnExamination({
        ...selectedOnExamination,
        generalExaminations: {
          ...generalExaminations,
          [fieldName]: val,
        },
      });
    } else {
      setPatientInfo({
        ...patientInfo,
        [fieldName]: val,
      });
    }
  };

  const handleAge = (fieldName, val) => {
    if (fieldName === 'months' && val >= 12) {
      alert('Months must be less than 12');
      return false;
    }
    if (fieldName === 'days') {
      let daysOfMonth = dob?.months
        ? moment().month(dob?.months).daysInMonth()
        : moment().daysInMonth();
      if (val > daysOfMonth) {
        alert(`Days must be less than ${daysOfMonth}`);
        return false;
      }
    }

    const dobData = patientInfo.id
      ? { ...dob, [fieldName]: val }
      : { ...patientInfo.dob, [fieldName]: val };

    setPatientInfo({
      ...patientInfo,
      dob: dobData,
    });
  };

  const actualWidth = prescriptionSetting?.page?.width?.quantity;
  const totalPadding = sizeConverter(
    actualWidth,
    parseFloat(prescriptionSetting?.page?.marginLeft?.quantity) +
      parseFloat(prescriptionSetting?.page?.marginRight?.quantity),
  );

  const pSettingsData = prescriptionSetting?.patientSetting || {};

  const formatMargin = (side) => {
    const quantity = pSettingsData?.[side]?.quantity ?? '';
    const unit = pSettingsData?.[side]?.unit ?? '';
    return `${quantity}${unit}`;
  };

  let patientSettingStyle = {
    marginLeft: formatMargin('marginLeft'),
    marginRight: formatMargin('marginRight'),
    marginTop: formatMargin('marginTop'),
    marginBottom: formatMargin('marginBottom'),
    ...(patientSettings?.borders?.left && {
      borderLeft:
        patientSettings?.borders?.thickness && patientSettings?.borders?.color
          ? `${patientSettings.borders.thickness} solid ${patientSettings.borders.color}`
          : '1px solid #d9d9d9',
    }),
    ...(patientSettings?.borders?.right && {
      borderRight:
        patientSettings?.borders?.thickness && patientSettings?.borders?.color
          ? `${patientSettings.borders.thickness} solid ${patientSettings.borders.color}`
          : '1px solid #d9d9d9',
    }),
    ...(patientSettings?.borders?.top && {
      borderTop:
        patientSettings?.borders?.thickness && patientSettings?.borders?.color
          ? `${patientSettings.borders.thickness} solid ${patientSettings.borders.color}`
          : '1px solid #d9d9d9',
    }),
    ...(patientSettings?.borders?.bottom && {
      borderBottom:
        patientSettings?.borders?.thickness && patientSettings?.borders?.color
          ? `${patientSettings.borders.thickness} solid ${patientSettings.borders.color}`
          : '1px solid #d9d9d9',
    }),
  };

  const appointmentDate = (appointmentDateTime) => {
    return appointmentInfo?.appointmentDateTime !== ''
      ? moment(appointmentInfo?.appointmentDateTime).format('DD/MM/YYYY')
      : moment().format('DD/MM/YYYY');
  };

  const printWeightHeight = (itemName) => {
    let dataInfo = selectedOnExamination?.generalExaminations;
    let result = '';
    if (itemName === 'height') {
      result = dataInfo?.heightInfo?.feet ? dataInfo.heightInfo.feet : '';
      result += dataInfo?.heightInfo?.inch
        ? '.' + dataInfo?.heightInfo?.inch
        : '';
      result += result ? ' ' + dataInfo?.heightInfo?.heightUnit : '';
    } else if (itemName === 'weight') {
      result = dataInfo?.weightInfo?.weight ? dataInfo.weightInfo?.weight : '';
      result += result ? ' ' + dataInfo?.weightInfo?.weightUnit : '';
    }
    return result;
  };

  const isVisibleField = (fieldName) => {
    const result = items?.find((item) => item.name === fieldName);
    return result ? result.isHideInInput !== true : true;
  };
  console.log('hideitems2222: ', hideItems?.['patient-section']);

  return (
    <>
      {firstRow?.length > 0 && (
        <Row
          className={`patient-section-print ${
            isPad ? '' : 'no-pad-patient-section'
          }`}
          style={isPad ? patientSettingStyle : {}}
        >
          {!hideItems?.['patient-section'] &&
            firstRow?.map((item, index) => {
              return (
                <Fragment key={index}>
                  {isPad ? (
                    item?.label?.properties?.isHidden ? (
                      <div
                        style={calculatePatientLabelPadding(
                          item,
                          'label',
                          actualWidth,
                          totalPadding,
                          isPad,
                        )}
                      ></div>
                    ) : (
                      <div
                        className={`${
                          item?.name === 'phoneNumber' ? 'print-phn-label' : ''
                        } ${item?.name === 'patientId' ? 'print-patient-id' : ''}
                      }`}
                        style={calculatePatientLabelPadding(
                          item,
                          'label',
                          actualWidth,
                          totalPadding,
                          isPad,
                        )}
                      >
                        {item?.label?.labelName}:
                      </div>
                    )
                  ) : (
                    ''
                  )}
                  {isPad ? (
                    <div
                      className="p-item-val"
                      style={
                        isPad
                          ? calculatePatientLabelPadding(
                              item,
                              'value',
                              actualWidth,
                              totalPadding,
                              isPad,
                            )
                          : {}
                      }
                    >
                      {item.name === 'age'
                        ? agePrint(dob, item?.unitProperties)
                        : item.name === 'date'
                          ? appointmentDate()
                          : item.name === 'weight' || item.name === 'height'
                            ? printWeightHeight(item.name)
                            : item.name === 'gender'
                              ? capitalizeFirstLetter(patientInfo[item.name])
                              : item.name === 'address'
                                ? patientInfo?.patientDetails?.address
                                : item.name === 'referenceBy'
                                  ? appointmentInfo?.otherDetails?.reference_by
                                  : item.name === 'bloodGroup'
                                    ? selectedOnExamination?.generalExaminations
                                        ?.bloodGroup
                                    : patientInfo[item.name]}
                    </div>
                  ) : (
                    <div className="n">
                      {item?.label?.labelName}: &nbsp;{' '}
                      {item.name === 'age'
                        ? agePrint(dob, item?.unitProperties)
                        : item.name === 'date'
                          ? appointmentDate()
                          : item.name === 'weight' || item.name === 'height'
                            ? printWeightHeight(item.name)
                            : item.name === 'gender'
                              ? capitalizeFirstLetter(patientInfo[item.name])
                              : item.name === 'address'
                                ? patientInfo?.patientDetails?.address
                                : item.name === 'referenceBy'
                                  ? appointmentInfo?.otherDetails?.reference_by
                                  : item.name === 'bloodGroup'
                                    ? selectedOnExamination?.generalExaminations
                                        ?.bloodGroup
                                    : patientInfo[item.name]}
                    </div>
                  )}
                </Fragment>
              );
            })}
        </Row>
      )}
      {secondRow?.length > 0 && (
        <Row
          className={`patient-section-print ${
            isPad ? '' : 'no-pad-patient-section'
          }`}
          style={isPad ? patientSettingStyle : {}}
        >
          {!hideItems?.['patient-section'] &&
            secondRow?.map((item, index) => {
              return (
                <Fragment key={index}>
                  {isPad ? (
                    item?.label?.properties?.isHidden ? (
                      <div
                        style={calculatePatientLabelPadding(
                          item,
                          'label',
                          actualWidth,
                          totalPadding,
                          isPad,
                        )}
                      ></div>
                    ) : (
                      <div
                        style={calculatePatientLabelPadding(
                          item,
                          'label',
                          actualWidth,
                          totalPadding,
                          isPad,
                        )}
                      >
                        {item?.label?.labelName}:
                      </div>
                    )
                  ) : (
                    ''
                  )}
                  {isPad ? (
                    <div
                      className="p-item-val"
                      style={
                        isPad
                          ? calculatePatientLabelPadding(
                              item,
                              'value',
                              actualWidth,
                              totalPadding,
                              isPad,
                            )
                          : {}
                      }
                    >
                      {item.name === 'age'
                        ? agePrint(dob, item?.unitProperties)
                        : item.name === 'date'
                          ? appointmentDate()
                          : item.name === 'weight' || item.name === 'height'
                            ? printWeightHeight(item.name)
                            : item.name === 'gender'
                              ? capitalizeFirstLetter(patientInfo[item.name])
                              : item.name === 'address'
                                ? patientInfo?.patientDetails?.address
                                : item.name === 'referenceBy'
                                  ? appointmentInfo?.otherDetails?.reference_by
                                  : item.name === 'bloodGroup'
                                    ? selectedOnExamination?.generalExaminations
                                        ?.bloodGroup
                                    : patientInfo[item.name]}
                    </div>
                  ) : (
                    <div className="n">
                      {item?.label?.labelName}: &nbsp;{' '}
                      {item.name === 'age'
                        ? agePrint(dob, item?.unitProperties)
                        : item.name === 'date'
                          ? appointmentDate()
                          : item.name === 'weight' || item.name === 'height'
                            ? printWeightHeight(item.name)
                            : item.name === 'gender'
                              ? capitalizeFirstLetter(patientInfo[item.name])
                              : item.name === 'address'
                                ? patientInfo?.patientDetails?.address
                                : item.name === 'referenceBy'
                                  ? appointmentInfo?.otherDetails?.reference_by
                                  : item.name === 'bloodGroup'
                                    ? selectedOnExamination?.generalExaminations
                                        ?.bloodGroup
                                    : patientInfo[item.name]}
                    </div>
                  )}
                </Fragment>
              );
            })}
        </Row>
      )}
      {thirdRow?.length > 0 && (
        <Row
          className={`patient-section-print ${
            isPad ? '' : 'no-pad-patient-section'
          }`}
          style={isPad ? patientSettingStyle : {}}
        >
          {!hideItems?.['patient-section'] &&
            thirdRow?.map((item, index) => {
              return (
                <Fragment key={index}>
                  {isPad ? (
                    item?.label?.properties?.isHidden ? (
                      <div
                        style={calculatePatientLabelPadding(
                          item,
                          'label',
                          actualWidth,
                          totalPadding,
                          isPad,
                        )}
                      ></div>
                    ) : (
                      <div
                        style={calculatePatientLabelPadding(
                          item,
                          'label',
                          actualWidth,
                          totalPadding,
                          isPad,
                        )}
                      >
                        {item?.label?.labelName}:
                      </div>
                    )
                  ) : (
                    ''
                  )}
                  {isPad ? (
                    <div
                      className="p-item-val"
                      style={
                        isPad
                          ? calculatePatientLabelPadding(
                              item,
                              'value',
                              actualWidth,
                              totalPadding,
                              isPad,
                            )
                          : {}
                      }
                    >
                      {item.name === 'age'
                        ? agePrint(dob, item?.unitProperties)
                        : item.name === 'date'
                          ? appointmentDate()
                          : item.name === 'weight' || item.name === 'height'
                            ? printWeightHeight(item.name)
                            : item.name === 'gender'
                              ? capitalizeFirstLetter(patientInfo[item.name])
                              : item.name === 'address'
                                ? patientInfo?.patientDetails?.address
                                : item.name === 'referenceBy'
                                  ? appointmentInfo?.otherDetails?.reference_by
                                  : item.name === 'bloodGroup'
                                    ? selectedOnExamination?.generalExaminations
                                        ?.bloodGroup
                                    : patientInfo[item.name]}
                    </div>
                  ) : (
                    <div className="n">
                      {item?.label?.labelName}: &nbsp;{' '}
                      {item.name === 'age'
                        ? agePrint(dob, item?.unitProperties)
                        : item.name === 'date'
                          ? appointmentDate()
                          : item.name === 'weight' || item.name === 'height'
                            ? printWeightHeight(item.name)
                            : item.name === 'gender'
                              ? capitalizeFirstLetter(patientInfo[item.name])
                              : item.name === 'address'
                                ? patientInfo?.patientDetails?.address
                                : item.name === 'referenceBy'
                                  ? appointmentInfo?.otherDetails?.reference_by
                                  : item.name === 'bloodGroup'
                                    ? selectedOnExamination?.generalExaminations
                                        ?.bloodGroup
                                    : patientInfo[item.name]}
                    </div>
                  )}
                </Fragment>
              );
            })}
        </Row>
      )}
      <Row className="patient-section mb-4">
        {/* If patient section for prescriptoin is set for doctor - patient section ordering */}
        {itemsOrder
          ? itemsOrder?.map((item, index) => {
              if (item?.name === 'name' && isVisibleField('name')) {
                return (
                  <div key={index} className="form-group form-inline">
                    <label htmlFor="name">Name:</label>
                    <Form.Control
                      type="text"
                      className={`name ${name ? '' : 'placeholder'}`}
                      placeholder="Enter your patient name"
                      value={name}
                      onChange={(e) => {
                        handlePatientInput('name', e.target.value);
                      }}
                      autoFocus
                    />
                  </div>
                );
              }

              if (item?.name === 'age' && isVisibleField('age')) {
                return (
                  <div
                    key={index}
                    className="form-group"
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      gap: '4px',
                    }}
                  >
                    <label
                      htmlFor="name"
                      style={{ marginBottom: 0, whiteSpace: 'nowrap' }}
                    >
                      Age:
                    </label>
                    <InputGroup className="age-input-group">
                      {(years?.enabled || !unitProperties) && (
                        <>
                          <Form.Control
                            size="sm"
                            type="number"
                            className={dob?.years ? '' : 'placeholder'}
                            defaultValue={dob?.years > 0 ? dob?.years : ''}
                            value={dob?.years > 0 ? dob?.years : ''}
                            placeholder="Yrs"
                            onChange={(e) => handleAge('years', e.target.value)}
                          />
                          {dob?.years > 0 && <span>{years?.label}</span>}
                        </>
                      )}
                      {months?.enabled && (
                        <>
                          <Form.Control
                            size="sm"
                            type="number"
                            className={dob?.months ? '' : 'placeholder'}
                            defaultValue={dob?.months > 0 ? dob?.months : ''}
                            value={dob?.months > 0 ? dob?.months : ''}
                            placeholder="Mth"
                            onChange={(e) =>
                              handleAge('months', e.target.value)
                            }
                          />
                          {dob?.months > 0 && <span>{months?.label}</span>}
                        </>
                      )}
                      {days?.enabled && (
                        <>
                          <Form.Control
                            size="sm"
                            type="number"
                            className={dob?.days ? '' : 'placeholder'}
                            defaultValue={dob?.days > 0 ? dob?.days : ''}
                            value={dob?.days > 0 ? dob?.days : ''}
                            placeholder="Day"
                            onChange={(e) => handleAge('days', e.target.value)}
                          />
                          {dob?.days > 0 && <span>{days?.label}</span>}
                        </>
                      )}
                      {hours?.enabled && (
                        <>
                          <Form.Control
                            size="sm"
                            type="number"
                            className={dob?.hours ? '' : 'placeholder'}
                            placeholder="Hr"
                            defaultValue={dob?.hours > 0 ? dob?.hours : ''}
                            value={dob?.hours > 0 ? dob?.hours : ''}
                            onChange={(e) => handleAge('hours', e.target.value)}
                          />
                          {dob?.hours > 0 && <span>{hours?.label}</span>}
                        </>
                      )}
                    </InputGroup>
                  </div>
                );
              }

              if (item?.name === 'gender' && isVisibleField('gender')) {
                return (
                  <div
                    key={index}
                    className="form-group form-inline"
                    style={{ gap: '6px', alignItems: 'center' }}
                  >
                    <label style={{ marginBottom: 0 }}>Gender:</label>
                    {['male', 'female', 'others'].map((g) => (
                      <label
                        key={g}
                        onClick={() => handlePatientInput('gender', g)}
                        style={{
                          display: 'inline-flex',
                          alignItems: 'center',
                          gap: '4px',
                          cursor: 'pointer',
                          marginBottom: 0,
                          fontSize: '13px',
                        }}
                      >
                        <span
                          style={{
                            width: '14px',
                            height: '14px',
                            borderRadius: '50%',
                            border: `2px solid ${gender === g ? '#228093' : '#228093'}`,
                            display: 'inline-flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            flexShrink: 0,
                          }}
                        >
                          {gender === g && (
                            <span
                              style={{
                                width: '6px',
                                height: '6px',
                                borderRadius: '50%',
                                background: '#228093',
                              }}
                            />
                          )}
                        </span>
                        {capitalizeFirstLetter(g)}
                      </label>
                    ))}
                  </div>
                );
              }

              if (
                item?.name === 'phoneNumber' &&
                isVisibleField('phoneNumber')
              ) {
                return (
                  <div key={index} className="form-group form-inline">
                    <label htmlFor="phoneNumber">Phone:</label>
                    <Form.Control
                      type="text"
                      className={`phone-number ${phoneNumber ? '' : 'placeholder'}`}
                      placeholder="01XXXXXXXXX"
                      value={phoneNumber}
                      onChange={(e) =>
                        handlePatientInput('phoneNumber', e.target.value)
                      }
                    />
                  </div>
                );
              }

              if (item?.name === 'weight' && isVisibleField('weight')) {
                return (
                  <div key={index} className="form-group form-inline">
                    <label htmlFor="weight">Weight:</label>
                    <Form.Control
                      type="text"
                      className={`weight-input ${
                        generalExaminations?.weightInfo?.weight
                          ? ''
                          : 'placeholder'
                      }`}
                      placeholder="XX"
                      style={{ width: '4rem' }}
                      value={generalExaminations?.weightInfo?.weight}
                      onChange={(e) =>
                        handlePatientInput('weight', e.target.value)
                      }
                    />
                    <Form.Select
                      className={`form-control ${gender ? '' : 'placeholder'}`}
                      size="sm"
                      value={generalExaminations?.weightInfo?.weightUnit}
                      style={{ paddingLeft: '0rem !important' }}
                      onChange={(e) =>
                        handlePatientInput('weightUnit', e.target.value)
                      }
                    >
                      <option value={'KG'}>KG</option>
                      <option value={'Pound'}>Pound</option>
                    </Form.Select>
                  </div>
                );
              }

              if (item?.name === 'height' && isVisibleField('height')) {
                return (
                  <div key={index} className="form-group form-inline">
                    <label htmlFor="height">Height:</label>
                    {generalExaminations?.heightInfo?.heightUnit &&
                      generalExaminations?.heightInfo?.heightUnit === 'Ft' && (
                        <Form.Select
                          className={`form-control ${gender ? '' : 'placeholder'}`}
                          size="sm"
                          value={generalExaminations?.heightInfo?.feet}
                          style={{ paddingLeft: '0.5rem !important' }}
                          onChange={(e) =>
                            handlePatientInput('feet', e.target.value)
                          }
                        >
                          <option value={''}>ft</option>
                          <option value={1}>1</option>
                          <option value={2}>2</option>
                          <option value={3}>3</option>
                          <option value={4}>4</option>
                          <option value={5}>5</option>
                          <option value={6}>6</option>
                          <option value={7}>7</option>
                        </Form.Select>
                      )}
                    {generalExaminations?.heightInfo?.heightUnit &&
                      generalExaminations?.heightInfo?.heightUnit === 'Ft' && (
                        <Form.Select
                          className={`form-control ${gender ? '' : 'placeholder'}`}
                          size="sm"
                          value={generalExaminations?.heightInfo?.inch}
                          style={{ paddingLeft: '0.5rem !important' }}
                          onChange={(e) =>
                            handlePatientInput('inch', e.target.value)
                          }
                        >
                          <option value={''}>in</option>
                          <option value={0}>0</option>
                          <option value={1}>1</option>
                          <option value={2}>2</option>
                          <option value={3}>3</option>
                          <option value={4}>4</option>
                          <option value={5}>5</option>
                          <option value={6}>6</option>
                          <option value={7}>7</option>
                          <option value={8}>8</option>
                          <option value={9}>9</option>
                          <option value={10}>10</option>
                          <option value={11}>11</option>
                        </Form.Select>
                      )}
                    {generalExaminations?.heightInfo?.heightUnit &&
                      generalExaminations?.heightInfo?.heightUnit === 'Cm' && (
                        <Form.Control
                          type="text"
                          // className={`weight-input ${weight ? '' : 'placeholder'}`}
                          placeholder="cm"
                          style={{ width: '4rem' }}
                          value={generalExaminations?.heightInfo?.feet}
                          onChange={(e) =>
                            handlePatientInput('feet', e.target.value)
                          }
                        />
                      )}
                    <Form.Select
                      className={`form-control ${gender ? '' : 'placeholder'}`}
                      size="sm"
                      value={generalExaminations?.heightInfo?.heightUnit}
                      style={{ paddingLeft: '0.5rem !important' }}
                      onChange={(e) =>
                        handlePatientInput('heightUnit', e.target.value)
                      }
                    >
                      <option value={'Ft'}>Feet</option>
                      <option value={'Cm'}>CM</option>
                    </Form.Select>
                  </div>
                );
              }

              if (item?.name === 'address' && isVisibleField('address')) {
                return (
                  <div key={index} className="form-group form-inline">
                    <label htmlFor="address">Address:</label>
                    <Form.Control
                      type="text"
                      className={`address-input ${gender ? '' : 'placeholder'}`}
                      placeholder=""
                      value={patientInfo?.patientDetails?.address}
                      onChange={(e) =>
                        handlePatientInput('address', e.target.value)
                      }
                    />
                  </div>
                );
              }

              if (
                item?.name === 'referenceBy' &&
                isVisibleField('referenceBy')
              ) {
                return (
                  <div key={index} className="form-group form-inline">
                    <label htmlFor="address">Reference By:</label>
                    <Form.Control
                      type="text"
                      className={`address-input ${gender ? '' : 'placeholder'}`}
                      placeholder="Reference Name"
                      value={appointmentInfo?.otherDetails?.reference_by}
                      onChange={(e) =>
                        handlePatientInput('reference_by', e.target.value)
                      }
                    />
                  </div>
                );
              }

              if (item?.name === 'bloodGroup' && isVisibleField('bloodGroup')) {
                return (
                  <div key={index} className="form-group form-inline">
                    <label htmlFor="bloodGroup">Blood Group:</label>
                    <Form.Select
                      className={`form-control ${gender ? '' : 'placeholder'}`}
                      size="sm"
                      value={generalExaminations?.bloodGroup}
                      style={{ paddingLeft: '0.5rem !important' }}
                      onChange={(e) =>
                        handlePatientInput('bloodGroup', e.target.value)
                      }
                    >
                      <option value={''}>Select</option>
                      <option value={'O+'}>O+</option>
                      <option value={'O-'}>O-</option>
                      <option value={'A+'}>A+</option>
                      <option value={'A-'}>A-</option>
                      <option value={'B+'}>B+</option>
                      <option value={'B-'}>B-</option>
                      <option value={'AB+'}>AB+</option>
                      <option value={'AB-'}>AB-</option>
                      <option value={'Unknown'}>Unkown</option>
                    </Form.Select>
                  </div>
                );
              }

              if (item?.name === 'date' && isVisibleField('date')) {
                return (
                  <div key={index} className="form-group form-inline">
                    <label htmlFor="date" className="date-label">
                      Date:
                    </label>
                    <span
                      className="pl-1 date-field"
                      style={{ fontWeight: 'normal', color: '#6e707e' }}
                    >
                      {moment().format('DD-MM-YYYY')}
                    </span>
                  </div>
                );
              }

              return '';
            })
          : ''}

        {itemsOrder ? (
          <div className="form-group form-inline">
            <span className="pl-1" onClick={() => setInfoModal(true)}>
              {/* <i className="fa fa-plus-circle" aria-hidden="true"></i>
              &nbsp;<span className="add-more-sm">Add More</span> */}
              <RightArrow className="right-arrow-add-more" />
            </span>
          </div>
        ) : (
          ''
        )}
        {/* If patient section for prescription is not set for docrtor    */}
        {!itemsOrder ? (
          <>
            {isVisibleField('name') && (
              <div className="form-group form-inline">
                <label htmlFor="name">Name:</label>
                <Form.Control
                  type="text"
                  className={`name ${name ? '' : 'placeholder'}`}
                  placeholder="Write your patient name"
                  value={name}
                  onChange={(e) => handlePatientInput('name', e.target.value)}
                  autoFocus
                />
              </div>
            )}
            {isVisibleField('age') && (
              <div className="form-group form-inline">
                <label htmlFor="name">Age:</label>
                <InputGroup className="age-input-group">
                  {(years?.enabled || !unitProperties) && (
                    <>
                      <Form.Control
                        size="sm"
                        type="number"
                        className={dob?.years ? '' : 'placeholder'}
                        defaultValue={dob?.years > 0 ? dob?.years : ''}
                        value={dob?.years > 0 ? dob?.years : ''}
                        placeholder="Years"
                        onChange={(e) => handleAge('years', e.target.value)}
                      />
                      {dob?.years > 0 && <span>{years?.label}</span>}
                    </>
                  )}
                  {months?.enabled && (
                    <>
                      <Form.Control
                        size="sm"
                        type="number"
                        className={dob?.months ? '' : 'placeholder'}
                        defaultValue={dob?.months > 0 ? dob?.months : ''}
                        value={dob?.months > 0 ? dob?.months : ''}
                        placeholder="Mth"
                        onChange={(e) => handleAge('months', e.target.value)}
                      />
                      {dob?.months > 0 && <span>{months?.label}</span>}
                    </>
                  )}
                  {days?.enabled && (
                    <>
                      <Form.Control
                        size="sm"
                        type="number"
                        className={dob?.days ? '' : 'placeholder'}
                        defaultValue={dob?.days > 0 ? dob?.days : ''}
                        value={dob?.days > 0 ? dob?.days : ''}
                        placeholder="Day"
                        onChange={(e) => handleAge('days', e.target.value)}
                      />
                      {dob?.days > 0 && <span>{days?.label}</span>}
                    </>
                  )}
                  {hours?.enabled && (
                    <>
                      <Form.Control
                        size="sm"
                        type="number"
                        className={dob?.hours ? '' : 'placeholder'}
                        placeholder="Hr"
                        defaultValue={dob?.hours > 0 ? dob?.hours : ''}
                        value={dob?.hours > 0 ? dob?.hours : ''}
                        onChange={(e) => handleAge('hours', e.target.value)}
                      />
                      {dob?.hours > 0 && <span>{hours?.label}</span>}
                    </>
                  )}
                </InputGroup>
              </div>
            )}
            {isVisibleField('gender') && (
              // <div className="form-group form-inline">
              //   <label htmlFor="gender">Gender:</label>
              //   <input
              //     type="radio"
              //     name="genderValue"
              //     id="gender-male"
              //     value="male"
              //     checked={gender === 'male'}
              //     onChange={(e) => handlePatientInput('gender', e.target.value)}
              //     style={{ cursor: 'pointer', marginLeft: '8px' }}
              //   />
              //   <label
              //     htmlFor="gender-male"
              //     style={{
              //       color: 'grey',
              //       fontSize: '14px',
              //       cursor: 'pointer',
              //       marginLeft: '4px',
              //       marginRight: '8px',
              //       marginBottom: 0,
              //     }}
              //   >
              //     Male
              //   </label>
              //   <input
              //     type="radio"
              //     name="genderValue"
              //     id="gender-female"
              //     value="female"
              //     checked={gender === 'female'}
              //     onChange={(e) => handlePatientInput('gender', e.target.value)}
              //     style={{ cursor: 'pointer', marginLeft: '8px' }}
              //   />
              //   <label
              //     htmlFor="gender-female"
              //     style={{
              //       color: 'grey',
              //       fontSize: '14px',
              //       cursor: 'pointer',
              //       marginLeft: '4px',
              //       marginRight: '8px',
              //       marginBottom: 0,
              //     }}
              //   >
              //     Female
              //   </label>
              //   <input
              //     type="radio"
              //     name="genderValue"
              //     id="gender-others"
              //     value="others"
              //     checked={gender === 'others'}
              //     onChange={(e) => handlePatientInput('gender', e.target.value)}
              //     style={{ cursor: 'pointer', marginLeft: '8px' }}
              //   />
              //   <label
              //     htmlFor="gender-others"
              //     style={{
              //       color: 'grey',
              //       fontSize: '14px',
              //       cursor: 'pointer',
              //       marginLeft: '4px',
              //       marginBottom: 0,
              //     }}
              //   >
              //     Others
              //   </label>
              // </div>
              <div
                className="form-group form-inline"
                style={{ gap: '6px', alignItems: 'center' }}
              >
                <label style={{ marginBottom: 0 }}>Gender:</label>
                {['male', 'female', 'others'].map((g) => (
                  <label
                    key={g}
                    onClick={() => handlePatientInput('gender', g)}
                    style={{
                      display: 'inline-flex',
                      alignItems: 'center',
                      gap: '4px',
                      cursor: 'pointer',
                      marginBottom: 0,
                      fontSize: '13px',
                    }}
                  >
                    <span
                      style={{
                        width: '14px',
                        height: '14px',
                        borderRadius: '50%',
                        border: `2px solid ${gender === g ? '#228093' : '#228093'}`,
                        display: 'inline-flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        flexShrink: 0,
                      }}
                    >
                      {gender === g && (
                        <span
                          style={{
                            width: '6px',
                            height: '6px',
                            borderRadius: '50%',
                            background: '#228093',
                          }}
                        />
                      )}
                    </span>
                    {capitalizeFirstLetter(g)}
                  </label>
                ))}
              </div>
            )}
            {isVisibleField('phoneNumber') && (
              <div className="form-group form-inline">
                <label htmlFor="gender">Phone:</label>
                <Form.Control
                  type="text"
                  className={`phone-number ${phoneNumber ? '' : 'placeholder'}`}
                  placeholder="01000-000000"
                  value={phoneNumber}
                  onChange={(e) =>
                    handlePatientInput('phoneNumber', e.target.value)
                  }
                />
              </div>
            )}
            <div className="form-group form-inline">
              <label htmlFor="date" className="date-label pr-2">
                Date:
              </label>
              <span
                className="date-field"
                style={{ fontWeight: 'normal', color: '#6e707e' }}
              >
                {moment().format('DD-MM-YYYY')}
              </span>
              <span className="pl-1" onClick={() => setInfoModal(true)}>
                {/* <i className="fa fa-plus-circle" aria-hidden="true"></i>
                        &nbsp;<span className="add-more-sm">Add More</span> */}
                <RightArrow className="right-arrow-add-more" />
                <span className="add-more-lg">Add Patient Information</span>
              </span>
            </div>
          </>
        ) : (
          ''
        )}
      </Row>

      <AddPatientInfo
        patientPicture={patientPicture}
        patientInfo={patientInfo}
        setPatientInfo={setPatientInfo}
        infoModal={infoModal}
        setInfoModal={setInfoModal}
        appointmentInfo={appointmentInfo}
        setAppointmentInfo={setAppointmentInfo}
        selectedOnExamination={selectedOnExamination}
        setSelectedOnExamination={setSelectedOnExamination}
      />
    </>
  );
};

export default memo(PatientSection);
